/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profession/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Profession({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem/Profession"
  
}) {
let professionalOtherEmployeeTypeNameValueData = fromData.useDataValue({ viewPath,
context: 'professional',
path: 'other.employee_type.name',
})
  return (<React.Fragment
>
<div
  data-testid="Profession.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="professional.other.employee_type.name"
 text={professionalOtherEmployeeTypeNameValueData}
/>
</div>
{children}
</React.Fragment>)
}